import {v4} from "uuid";

import {IEReservationQueueDto} from "modules/queues/Dtos/IEReservationQueueDto";
import {Status} from "modules/queues/types/Status";
import {FieldType} from "modules/queues/types/FieldType";

export const createQueue = (
  id: string = v4(),
  groupId: string = "groupId",
  queue?: IEReservationQueueDto
): IEReservationQueueDto => {
  return {
    id: `eeee-ffff-qqqq-${id}`,
    name: `Kolejka ${id} w${groupId}`,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
    firstAvailableIntervalDate: "2021-2-16",
    status: Status.Active,
    formFields: [
      {
        label: "Numer telefonu",
        name: "phone",
        required: true,
        fieldType: FieldType.PhoneField
      },
      {
        label: "Nazwa",
        name: "name",
        required: false,
        fieldType: FieldType.TextArea
      },
    ],
    ...queue,
  };
};
